import AppPicture from '~/components/react/AppPicture';

interface HostessAvatarProps {
  avatar: any; // string URL | AppPicture image object | null
  name: string;
  isMyActivity: boolean;
}

export function HostessAvatar({ avatar, name, isMyActivity }: HostessAvatarProps) {
  return (
    <figure
      data-slot="avatar"
      className={`relative size-[2.5rem] overflow-hidden border border-gray-300 bg-brand/10 ${
        isMyActivity ? 'rounded' : 'rounded-full'
      }`}
    >
      {avatar ? (
        typeof avatar === 'string' ? (
          <img
            src={avatar}
            loading="lazy"
            className="w-full h-full object-cover"
            alt={name}
          />
        ) : (
          <AppPicture
            img={avatar}
            sources={[['default', {}]]}
            imgClass="w-full h-full object-cover"
            alt={name}
          />
        )
      ) : (
        <span className="flex w-full h-full items-center justify-center text-sm text-brand/70">
          {name.charAt(0)}
        </span>
      )}
    </figure>
  );
}
